import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import ApiService from '../../core/service/api-service';

export default function StudyEditMetadataModal({ studyRow, onSaved }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        try {
            setLoading(true);

            const response = await ApiService.Study.UpdateStudyMetadata({
                studyId: studyRow.id,
                accessionNumber: values.accessionNumber,
                studyDescription: values.studyDescription,
            });

            if (response.success) {
                onSaved();
            }
        } catch (error) {
            console.error('Update Failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
                accessionNumber: studyRow.accessionNumber,
                studyDescription: studyRow.studyDescription,
            }}
        >
            <Form.Item
                label={t('Accession Number')}
                name="accessionNumber"
                rules={[
                    {
                        message: t('Please input accession number'),
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label={t('Study Description')}
                name="studyDescription"
                rules={[
                    {
                        message: t('Please input study description'),
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    {t('Save')}
                </Button>
            </Form.Item>
        </Form>
    );
}

